/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TimeSeriesPoint } from './TimeSeriesPoint';
import {
    TimeSeriesPointFromJSON,
    TimeSeriesPointFromJSONTyped,
    TimeSeriesPointToJSON,
} from './TimeSeriesPoint';

/**
 * 
 * @export
 * @interface CloudStorageTraffic
 */
export interface CloudStorageTraffic {
    /**
     * 
     * @type {Array<TimeSeriesPoint>}
     * @memberof CloudStorageTraffic
     */
    receivedBytes?: Array<TimeSeriesPoint>;
}

/**
 * Check if a given object implements the CloudStorageTraffic interface.
 */
export function instanceOfCloudStorageTraffic(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CloudStorageTrafficFromJSON(json: any): CloudStorageTraffic {
    return CloudStorageTrafficFromJSONTyped(json, false);
}

export function CloudStorageTrafficFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloudStorageTraffic {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'receivedBytes': !exists(json, 'receivedBytes') ? undefined : ((json['receivedBytes'] as Array<any>).map(TimeSeriesPointFromJSON)),
    };
}

export function CloudStorageTrafficToJSON(value?: CloudStorageTraffic | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'receivedBytes': value.receivedBytes === undefined ? undefined : ((value.receivedBytes as Array<any>).map(TimeSeriesPointToJSON)),
    };
}

